import { render, staticRenderFns } from "./SchoolCareersWebsite.vue?vue&type=template&id=23aa66a6&"
import script from "./SchoolCareersWebsite.vue?vue&type=script&lang=js&"
export * from "./SchoolCareersWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports